import React, { useEffect } from "react";

interface AlertModalProps {
  onClose: () => void;
  isOpen: boolean;
}

const AlertModal: React.FC<AlertModalProps> = ({ onClose, isOpen }) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleKeyDown);
    } else {
      document.removeEventListener("keydown", handleKeyDown);
    }

    // Cleanup listener when component unmounts or modal closes
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white p-6 rounded-lg shadow-xl max-w-lg w-full max-h-[80vh] flex flex-col relative">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-300 hover:text-gray-400 text-2xl font-bold leading-none"
          aria-label="Close"
        >
          ×
        </button>

        <h2 className="text-xl font-semibold mb-4 text-gray-800">
          SM AI Data Reference
        </h2>

        <p className="mb-2">
          I am SM AI: SM Assistant Messaging Interface, SAMI for short. Here are the tables I am referring to.
        </p>
        {/* <p>Hi! I’m SAMI, your SM Assistant Messaging Interface. Here’s the data I can refer to:</p> */}
        <div className="overflow-y-auto mb-4 p-2 max-h-[60vh]">
          <p className="text-slate-600 whitespace-pre-wrap">
<span className="text-lg font-bold">
Customers
</span>
{`
- gender
- date joined
- age
- default mall
- last login
- city
- postal code
- status
- age group
- age range
- birth month

`}
<span className="text-lg font-bold">
Tenants
</span>
{`
- vendor code
- mall
- category
- sub-type

`}
<span className="text-lg font-bold">
Products
</span>
{`
- sku
- category
- variant
- retail price
- inventory tracked

`}
<span className="text-lg font-bold">
Orders
</span>
{`
- order code
- date and time
- order status
- channel
- delivery type
- payment method
- voucher code
- total gross amount
- total discount
- total sales amount
- delivery fee
- price paid
- payment fee
- net settlement
- payout eligible
- payout status
- shipping
- address
- city order origin
- province order origin
- postal code order origin

`}
<span className="text-lg font-bold">
Order Items
</span>
{`
- sku
- quantity
- unit price
- item discount
- item total
- shipped datetime
- returned flag
- store order code
- order status

`}
<span className="text-lg font-bold">
Coupons Redemption
</span>
{`
- mall
- redemption type
- date claimed
- title
- vertical
- report vertical
- status
- redemption status
- amount
- redeemed count
- claimed count
- expired count
- total swipe
`}
          </p>
        </div>

        <div className="flex justify-end">
          <button
            type="button"
            onClick={onClose}
            className="flex items-center justify-center gap-1 px-3 py-2 rounded-xl bg-blue-700 hover:bg-blue-800 text-white text-sm disabled:bg-blue-400 disabled:cursor-not-allowed"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default AlertModal;
